// src/components/payments/PaymentCard.jsx
import { GlassPanel } from "../ui/GlassPanel";

export function PriceCard({
  title,
  price,
  cadence,
  ctaLabel,
  features = [],
  highlight = false,
  choose,
  disabled = false,
}) {
  return (
    <GlassPanel
      className={`relative flex flex-col gap-2 rounded-3xl h-full ${
        highlight ? "ring-2 ring-primary" : ""
      } ${disabled ? "opacity-70" : ""}`}
    >
      {highlight && (
        <span className="absolute -top-3 left-5 text-[11px] px-2 py-0.5 rounded-full bg-primary text-greyscale-1 tracking-wide">
          Most popular
        </span>
      )}
      <h3 className="subtitle-text">{title}</h3>
      <div className="flex items-end gap-1">
        <span className="text-3xl font-semibold ">{price}</span>
        {cadence ? <span className="text-xs mb-1">{cadence}</span> : null}
      </div>

      <ul className="py-1">
        {features.map((f, i) => (
          <li key={i} className="flex gap-2 items-center justify-start">
            <span className="h-1.5 w-1.5 rounded-full bg-primary inline-block" />
            {f}
          </li>
        ))}
      </ul>

      <div className="mt-auto w-full flex flex-row justify-end">
        <button
          type="button"
          onClick={disabled ? undefined : choose}
          disabled={disabled}
          className={`inline-flex primary-button ${
            disabled ? "!bg-greyscale-4 cursor-default" : ""
          }`}
          aria-disabled={disabled}
        >
          {ctaLabel}
        </button>
      </div>
    </GlassPanel>
  );
}
